import {ValidationRuleModel} from './validation-rule.model';
import {IntegrationMode} from './integration-mode.model';
import {FilterAction} from '@app/core/model/filtering/entity-filter-model';

export class ValidationRuleWithStatModel extends ValidationRuleModel {
    public invalidEntitiesCount = 0;
    public skippedEntitiesCount = 0;
}

export class GroupedValidationRuleWithStat {
    constructor(
        public key: string = null,
        public values: ValidationRuleWithStatModel[] = <ValidationRuleWithStatModel[]>[],
        public invalidEntitiesCount: number = 0,
        public skippedEntitiesCount: number = 0,
        public duplicatesCount: number = 0,
        public expanded: boolean = false
    ) { }

    calculateTotal() {
        this.invalidEntitiesCount = this.values.reduce((total, statItem) => total + statItem.invalidEntitiesCount, 0);
        this.skippedEntitiesCount = this.values
            .filter((stat: ValidationRuleWithStatModel) => stat.action === FilterAction.VALIDATE_AND_SKIP)
            .reduce((total, statItem) => total + statItem.invalidEntitiesCount, 0);
    }

    toggleRow() {
        this.expanded = !this.expanded;
    }
}

export class ValidationRuleWithStatByIntegrationMode {
    constructor(
        public key: IntegrationMode = null,
        public groupedStat: GroupedValidationRuleWithStat[] = <GroupedValidationRuleWithStat[]>[]
    ) { }
}
